import styled from 'styled-components';
const StyledServiceContainer = styled.div``;
export default StyledServiceContainer;
